module.exports = __webpack_public_path__ + "img/invest2.7da93724.jpeg";